import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import LeaderboardSection from '../components/LeaderboardSection';
import PlayAlongSection from '../components/PlayAlongSection';
import LeaderboardDividerSection from '../components/LeaderboardDividerSection';
import { applyPageMeta } from '../lib/seo';
import { PAGE_META } from '../lib/routeMeta';
import { useEventState } from '../lib/eventState';

export default function LeaderboardPage() {
  // Contest-end / Free Play (GHS5-85): the web leaderboard retires once the
  // contest ends — the live standings move in-game. Send visitors home. We
  // wait for the event-state fetch (loading) so we don't bounce mid-contest.
  const { contestEnded, loading } = useEventState();

  useEffect(() => {
    applyPageMeta(PAGE_META.leaderboard);
  }, []);

  if (!loading && contestEnded) return <Navigate to="/" replace />;

  return (
    <>
      <LeaderboardSection />
      <PlayAlongSection />
      <LeaderboardDividerSection />
    </>
  );
}
